import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Navbar.scss";

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const handleClick = () => setNav(!nav);

  return (
    <nav className="navbar">
      <div>
        <h1 className="logo">
          marko<span className="dot">.</span>dju
        </h1>
      </div>
      <ul className="navbar-links">
        <li>
          <a href="#header">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#skills">Skills</a>
        </li>
        <li>
          <a href="#projects">Projects</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>

      <div onClick={handleClick} className="md:hidden z-10">
        {!nav ? <FaBars color="#d1d5db" /> : <FaTimes color="#d1d5db" />}
      </div>

      <ul
        className={
          !nav
            ? "hidden"
            : "absolute top-0 left-0 w-full h-screen bg-[#0a192f] flex flex-col justify-center items-center"
        }
      >
        <li className="py-6 text-4xl text-[#d1d5db]">
          <li>
            <a onClick={handleClick} href="#header">
              Home
            </a>
          </li>
        </li>
        <li className="py-6 text-4xl text-[#d1d5db]">
          <li>
            <a onClick={handleClick} href="#about">
              About
            </a>
          </li>
        </li>
        <li className="py-6 text-4xl text-[#d1d5db]">
          <li>
            <a onClick={handleClick} href="#skills">
              Skills
            </a>
          </li>
        </li>
        <li className="py-6 text-4xl text-[#d1d5db]">
          <li>
            <a onClick={handleClick} href="#projects">
              Projects
            </a>
          </li>
        </li>
        <li className="py-6 text-4xl text-[#d1d5db]">
          <li>
            <a onClick={handleClick} href="#contact">
              Contact
            </a>
          </li>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
